// ── Backend V2 API ──────────────────────────────────────────
const BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

function getToken() {
  return localStorage.getItem("accessToken") || "";
}

function authHeaders() {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

// ── Public ──────────────────────────────────────────────────

export async function fetchProjects() {
  const response = await fetch(`${BASE}/api/projects`);
  if (!response.ok) throw new Error("Failed to fetch projects");
  const data = await response.json();
  return data.project;
}

// ── Admin (protected) ───────────────────────────────────────

export async function insertProject(newProject) {
  const response = await fetch(`${BASE}/api/projects`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(newProject),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || "Failed to insert project");
  }
  return response.json();
}

export async function updateProject(id, updatedProject) {
  const response = await fetch(`${BASE}/api/projects/${id}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(updatedProject),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update project");
  }
  return response.json();
}

export async function deleteProject(id) {
  const response = await fetch(`${BASE}/api/projects/${id}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error("Failed to delete project");
}
